//The contents of this file have been generated automatically. Do not edit this file.

import * as t from 'io-ts';
import { isRight } from 'fp-ts/lib/Either';
import { fetchGeneralRaw, FetchGeneralRawResponseType } from 'src_common/common/fetch';
import { ApiTimeLog } from 'src_common/server/webDriver/logFormat';


export interface ParamsType {
    requestBody: {
        banner_id: number,
        collection: string,
    },
}


const createGuard = <A>(code: number, decoder: t.Type<A, A, unknown>): ((data: unknown) => A) => {
    return (data: unknown): A => {
        const decodeResult = decoder.decode(data);
        if (isRight(decodeResult)) {
            return decodeResult.right;
        }
        throw Error(`Response decoding error /api-proxy/staff/casino/banners/delete -> delete -> ${code}`);
    };
};

const Response200IO = t.interface({
    deleted_rows: t.number,
});
export type Response200Type = {
    deleted_rows: number,
};
export const decodeResponse200 = createGuard(200, Response200IO);

const Response400IO = t.string;
export type Response400Type = string;
export const decodeResponse400 = createGuard(400, Response400IO);

const Response401IO = t.string;
export type Response401Type = string;
export const decodeResponse401 = createGuard(401, Response401IO);

const Response500IO = t.string;
export type Response500Type = string;
export const decodeResponse500 = createGuard(500, Response500IO);



type ExtraHeadersType = Record<string, string>


/**
 * @deprecated - Please use this method "openapiBannersStaffDeleteBannerRequest"
 */
export const openapi_banners_staff_delete_banner = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<FetchGeneralRawResponseType> => {
    
        
    const query = '';
    const url = `${api_url}/api-proxy/staff/casino/banners/delete${query}`;
    
    const method = 'DELETE';
    const paramsFetch = {
        url,
        body: params.requestBody,
        backendToken,
        timeout: api_timeout,
        extraHeaders,
    };

    const apiTime = ApiTimeLog.createWithProcessEnv(method, url);
    const response = await fetchGeneralRaw(method, paramsFetch);
    apiTime.show(response.status);
    return response;
};


export type OpenapiBannersStaffDeleteBannerParamsType = ParamsType;

export type OpenapiBannersStaffDeleteBannerResponseType = {
    status: 200,
    body: Response200Type,
} | {
    status: 400,
    body: Response400Type,
} | {
    status: 401,
    body: Response401Type,
} | {
    status: 500,
    body: Response500Type,
};

export type OpenapiBannersStaffDeleteBannerResponse200Type = Response200Type;

export const openapiBannersStaffDeleteBannerRequest = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<OpenapiBannersStaffDeleteBannerResponseType> => {
    const response = await openapi_banners_staff_delete_banner(api_url, api_timeout, backendToken, params, extraHeaders);
    const { status, body } = response;

    let data: Object;

    try {
        data = JSON.parse(body);
    } catch (_err) {
        console.warn(`Http status ${status} - json was expected`);
        data = {};
    }
    
    if (status === 200) {
        return { status: 200, body: decodeResponse200(data) };
    }

    if (status === 400) {
        return { status: 400, body: decodeResponse400(data) };
    }

    if (status === 401) {
        return { status: 401, body: decodeResponse401(data) };
    }

    if (status === 500) {
        return { status: 500, body: decodeResponse500(data) };
    }

    throw new Error(`openapiBannersStaffDeleteBannerRequest - unhandled response ${response.status}`);
};

